import React, { Component } from 'react';

import ProgramHighlight from '@tvguide/components/programhighlight';

export default class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getChannels(this.props.nid).catch(error => {
      console.error(error);
    });
  }

  render() {
    return (
      <ProgramHighlight
        title={this.props.railTitle}
        railType={this.props.railType}
        railCategory={this.props.railCategory}
      />
    );
  }
}
